export class CmblAddress {

  public address1: string;
  public address2: string;
  public address3: string;
  public city: string;
  public state: string;
  public zip: string;
  public country: string;
  public countryName: string;


  public static fromDto(d: any): CmblAddress {
    if (!d) {
      return null;
    }

    const address = new CmblAddress();

    address.address1    = d.address1;
    address.address2    = d.address2;
    address.address3    = d.address3;
    address.city        = d.city;
    address.state       = d.state;
    address.zip         = d.zip;
    address.country     = d.country;
    address.countryName = d.country_name || d.country;

    return address;

  }
}
